var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from "vue-facing-decorator";
import { AuthClient, ConfirmUserPasswordResetCommand, UserPasswordResetConfirmationModel } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { DateHelper } from "@/app/utils/date-helper";
import PasswordLegendVue from "@/app/vues/components/password-legend";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const authClient = new AuthClient(window.apiUrl);
let ChangePasswordVue = class ChangePasswordVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.working = false;
        this.attemptedTokenValidation = false;
        this.tokenIsValid = false;
        this.passwordChanged = false;
        this.token = "";
        this.password = "";
        this.passwordConfirmation = "";
    }
    // method
    created() {
        // we manipulate the query string manually to ensure that it is kept intact
        // e.g. vue router will split query parameters if & is present.
        let query = window.location.search.substring(1);
        this.token = query ? query.replace("token=", "") : "";
        this.validateToken();
    }
    ;
    validateToken() {
        if (!this.token || !this.token.length) {
            this.attemptedTokenValidation = true;
            return;
        }
        this.working = true;
        authClient
            .validatePasswordResetToken(this.token)
            .then(response => {
            if (!response)
                return;
            this.tokenIsValid = true;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.attemptedTokenValidation = true;
        });
    }
    ;
    changePassword() {
        if (!this.tokenIsValid)
            return;
        const handleSubmitAction = this.handleSubmit(() => {
            this.working = true;
            let command = new ConfirmUserPasswordResetCommand();
            command.requestModel = new UserPasswordResetConfirmationModel({
                passwordResetToken: this.token,
                newPassword: this.password,
                newPasswordConfirmation: this.passwordConfirmation,
                timezoneOffset: DateHelper.getTimezoneOffset()
            });
            authClient
                .confirmPasswordReset(command)
                .then(response => {
                Notifier.onOk(`Your password has been updated. You may login now.`);
                this.passwordChanged = true;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        }, () => {
            Notifier.onError("Please check that you have correctly entered all password fields.");
        });
        handleSubmitAction();
    }
    ;
    // computed
    get statusText() {
        if (this.passwordChanged)
            return "Done!";
        return this.working ? "Working..." : "Change password";
    }
    ;
};
ChangePasswordVue = __decorate([
    Component({
        name: "ChangePasswordVue",
        components: { PasswordLegendVue },
        setup() {
            let phoneRegExp = new RegExp("^(?=.*[0-9])[- +()0-9]+$");
            const { errors, handleSubmit, defineInputBinds, setValues, setFieldValue } = useForm({
                validationSchema: yup.object({
                    password: yup.string().trim().required().customPassword(),
                    passwordConfirmation: yup.string().trim().required().oneOf([yup.ref('password')]),
                }),
            });
            const passwordVal = defineInputBinds('password');
            const passwordConfirmationVal = defineInputBinds('passwordConfirmation');
            return {
                errors,
                handleSubmit,
                passwordVal,
                passwordConfirmationVal
            };
        }
    })
], ChangePasswordVue);
export default ChangePasswordVue;
